import type { CoverageOptionDto } from '../../../../../api/submissions/submission-coverages.types';
import type { SubmissionDetailsDto } from '../../../../../api/submissions/submissions.api.types';
import type { AccountDto, PrimeXProductType } from '../../../../../types';
import type { Nullable } from '../../../../../types/common/utility';
import type {
  RateModifier,
  RaterXCoverage,
  RaterXPreset,
  RiskData,
} from '../api/types/rater-x-preset';
import type { createActionHandlers } from '../reducer';

/* represents the base type of all pages */
export interface PrimeXQuoteState {
  account: AccountDto;
  agencyId: string;
  risk: Record<string, RiskData>;
  effectiveDate: string;
  endDate: string;
  productType: PrimeXProductType;
  raterX: RaterXPreset;
  global: RaterXPreset['global'];
  componentGlobals: Nullable<
    Record<string, { lockValues: Nullable<string[]> } & RaterXPreset['global']>
  >;
  fieldValues: Record<string, unknown>[];
  coverageState: CoverageState;
  enableRaterXRecalculate: boolean | undefined;
  globalChanged: boolean | undefined;
  ratingOptions: RatingOptions;
  commissionRate: number;
  quoteCommissionRate: number;
  isAgencyBilled: boolean;
  agencyName: string;
  marketType: string;
  uiSettings: UiSettings;
  submission?: SubmissionDetailsDto;
  coverageOption?: CoverageOptionDto;
  brokerFee: number | undefined;
}

export type RatingOptions = Record<
  string,
  RateModifier & {
    readOnly: boolean;
    isPegValue?: boolean;
    isDirty?: boolean;
    productType?: PrimeXProductType;
  }
>;

export type PrimeXQuoteHandlers = ReturnType<typeof createActionHandlers>;

export enum GlobalFieldNames {
  limit = 'limit',
  territorialLimit = 'territorialLimit',
  basisOfCover = 'basisOfCover',
  waitingPeriod = 'waitingPeriod',
  deductible = 'deductible',
  retroactive = 'retroactive',
  productVersion = 'productVersion',
  carrier = 'carrier',
}

export type GlobalFieldKeys = keyof typeof GlobalFieldNames;

export enum RaterOptionKeys {
  carrier = 'carrier',
  productVersion = 'productVersion',
}

export type RaterOptionKeysType = keyof typeof RaterOptionKeys;

export type GlobalFieldValues<T = string | number> = {
  options?: Array<T>;
  value?: T;
  isCustomDateAllowed?: boolean;
  maxDate?: string;
  defaultDate?: string;
};

export type CoverageState = Record<
  string,
  RaterXCoverage & {
    isPegValue?: boolean;
    isDirty?: boolean;
    productType?: PrimeXProductType;
  }
>;

export type ModalConfig = {
  modal: any;
};

export type UiSettings = {
  showCoverageTerritorialLimit: boolean;
  showCoverageBasisOfCover: boolean;
  showCoverageWaitingPeriods: boolean;
  showCoverageRetroactiveDate: boolean;
  showGlobalWaitingPeriod: boolean;
  showCoverageEndDate: boolean;
  showClassDescription: boolean;
  showCommissionSlider: boolean;
  showRenewalToggle: boolean;
  showSectionCollapseToggle: boolean;
};
